import { render, staticRenderFns } from "./HelloUser.vue?vue&type=template&id=5db135ac&scoped=true&"
import script from "./HelloUser.vue?vue&type=script&lang=ts&"
export * from "./HelloUser.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5db135ac",
  null
  
)

export default component.exports